import axios from 'axios';

const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

// Autenticación
export const register = (data) => api.post('/auth/register', data);
export const login = (data) => api.post('/auth/login', data);
export const logout = () => api.post('/auth/logout');
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const resetPassword = (token, password) => api.post('/auth/reset-password', { token, password });
export const changePassword = (current_password, new_password) => api.post('/auth/change-password', { current_password, new_password });

// Perfil
export const getProfile = () => api.get('/profile');
export const updateProfile = (data) => api.patch('/profile', data);
export const uploadAvatar = (file) => {
  const formData = new FormData();
  formData.append('avatar', file);
  return api.post('/profile/avatar', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const uploadLogo = (file) => {
  const formData = new FormData();
  formData.append('logo', file);
  return api.post('/profile/logo', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Servicios
export const createService = (data) => api.post('/services', data);
export const getMyServices = () => api.get('/services/mine');
export const updateService = (id, data) => api.patch(`/services/${id}`, data);
export const getServiceCatalog = () => api.get('/services/catalog');

// Referrals
export const createReferral = (data) => api.post('/referrals', data);
export const getSentReferrals = () => api.get('/referrals/sent');
export const getReceivedReferrals = () => api.get('/referrals/received');
export const providerRespond = (id, data) => api.patch(`/referrals/${id}/provider-response`, data);
export const editOwnReferral = (id, data) => api.patch(`/referrals/${id}`, data);
export const deleteOwnReferral = (id) => api.delete(`/referrals/${id}`);

// Admin
export const getAdminUsers = () => api.get('/admin/users');
export const updateAdminUser = (id, data) => api.patch(`/admin/users/${id}`, data);
export const deleteAdminUser = (id) => api.delete(`/admin/users/${id}`);
export const editAdminUserProfile = (id, data) => api.patch(`/admin/users/${id}/edit-profile`, data);
export const bulkTempPasswords = (ids) => api.post('/admin/users/bulk-temp-passwords', ids ? { ids } : {});
export const getAdminServices = () => api.get('/admin/services');
export const getAdminReferrals = () => api.get('/admin/referrals');
export const getDuplicateReferrals = () => api.get('/admin/referrals/duplicates');
export const resolveReferral = (id, data) => api.patch(`/admin/referrals/${id}/resolve`, data);
export const editReferral = (id, data) => api.patch(`/admin/referrals/${id}`, data);
export const deleteReferral = (id) => api.delete(`/admin/referrals/${id}`);
export const getAdminCommissions = () => api.get('/admin/commissions');
export const markCommissionPaid = (id) => api.patch(`/admin/commissions/${id}/mark-paid`);
export const markCommissionUnpaid = (id) => api.patch(`/admin/commissions/${id}/mark-unpaid`);

// Estadísticas
export const getAdminStats = (from, to) => api.get('/admin/stats', { params: from && to ? { from, to } : {} });
export const getMyStats = (from, to) => api.get('/stats/mine', { params: from && to ? { from, to } : {} });
export const getMyCommissions = () => api.get('/commissions/mine');
export const getMyStatement = () => api.get('/statement/mine');

// Eventos (Café HUB / Junta Mensual)
export const getUpcomingEvents = () => api.get('/events/upcoming');
export const checkinEvent = (id) => api.post(`/events/${id}/checkin`);
export const cancelCheckin = (id) => api.delete(`/events/${id}/checkin`);
export const getMyAttendance = () => api.get('/events/attendance/mine');
export const getEventTypes = () => api.get('/event-types');

// Invitados
export const createInvitado = (data) => api.post('/invitados', data);
export const getMyInvitados = () => api.get('/invitados/mine');
export const linkInvitadoToEvent = (id, eventId) => api.patch(`/invitados/${id}/link-event`, { event_id: eventId });

// Admin: eventos
export const createAdminEvent = (data) => api.post('/admin/events', data);
export const getAdminEvents = () => api.get('/admin/events');
export const updateAdminEvent = (id, data) => api.patch(`/admin/events/${id}`, data);
export const getAdminEventAttendance = (id) => api.get(`/admin/events/${id}/attendance`);
export const adminRemoveAttendance = (eventId, userId) => api.delete(`/admin/events/${eventId}/attendance/${userId}`);
export const createAdminEventType = (data) => api.post('/admin/event-types', data);
export const updateAdminEventType = (key, data) => api.patch(`/admin/event-types/${key}`, data);
export const setAdminAttendanceStatus = (eventId, userId, status) => api.patch(`/admin/events/${eventId}/attendance/${userId}`, { status });
export const getAdminAttendanceHistory = () => api.get('/admin/attendance-history');
export const getAdminAttendanceHistoryDetail = (userId) => api.get(`/admin/attendance-history/${userId}`);

// Admin: invitados
export const getAdminInvitados = () => api.get('/admin/invitados');
export const updateAdminInvitado = (id, status) => api.patch(`/admin/invitados/${id}`, { status });
export const convertInvitadoToMember = (id) => api.post(`/admin/invitados/${id}/convert-to-member`);
export const confirmInvitadoAttendance = (id) => api.post(`/admin/invitados/${id}/confirm-attendance`);

// Admin: log de auditoría
export const getAuditLog = () => api.get('/admin/audit-log');

// Admin: perfil completo de un miembro
export const getAdminUserFullProfile = (id) => api.get(`/admin/users/${id}/full-profile`);

// Notificaciones
export const getNotifications = () => api.get('/notifications');
export const getUnreadNotificationCount = () => api.get('/notifications/unread-count');
export const markNotificationRead = (id) => api.patch(`/notifications/${id}/read`);
export const markAllNotificationsRead = () => api.patch('/notifications/read-all');

// Notificaciones push (navegador/PWA)
export const getVapidPublicKey = () => api.get('/push/vapid-public-key');
export const subscribePush = (subscription) => api.post('/push/subscribe', subscription);
export const unsubscribePush = (endpoint) => api.post('/push/unsubscribe', { endpoint });

export default api;
